export const getMutePreference = () => localStorage.getItem("muted") === "1";

export const setMutePreference = muted =>
  muted ? localStorage.setItem("muted", "1") : localStorage.removeItem("muted");
